import { httpOrder } from "@/utils/httpOrder"
import { OrderHostModel } from "../../Model/common/ordeHost"

export const orderHost = {
    getCompanyList:async(data:Partial<OrderHostModel.GetCompanyListRequest>)=>{
        const res = await httpOrder.post<OrderHostModel.BaseResponse<OrderHostModel.GetCompanyListResponse>>('/RestfulApi/yxt/company/list',data)
        return res.data
    }
}